import MembershipHelpers from "helpers/membership-helpers";
import { parseISOWithoutTime } from "./date-helpers";
import { addDays, format, isSameMonth } from "date-fns";
import { dateFnsFormats } from "rtr-constants";

export const PanelNames = {
  ZIP: "zip",
  SIZE: "size",
  DUE_DATE: "maternity",
  MATERNITY_SIZE: "maternitySize",
  DUE_DATE_EDIT: "dueDateEdit",
  EVENT: "date_search",
  DATE: "calendar",
  AVAILABILITY: "availability",
  SUPERBAR_AVAILABILITY: "superbar-availability",
};

export const ZipPanelNames = [PanelNames.ZIP];

export const SizePanelNames = [
  PanelNames.SIZE,
  PanelNames.DUE_DATE,
  PanelNames.MATERNITY_SIZE,
  PanelNames.DUE_DATE_EDIT,
];

export const AvailabilityPanelNames = [PanelNames.EVENT, PanelNames.DATE, PanelNames.AVAILABILITY];

export const MaternityPanelNames = [PanelNames.DUE_DATE, PanelNames.MATERNITY_SIZE, PanelNames.DUE_DATE_EDIT];

export const isFilteredByShippingAddress = (userData = {}, gridView = {}) => {
  const { isUnlimited, isRtrUpdate } = gridView;
  if (!isUnlimited && !isRtrUpdate) {
    return false;
  }

  return MembershipHelpers.isSubscriptionMember(userData);
};

export const isFilteredByShippingAddressNext = (userData = {}) => {
  return MembershipHelpers.isSubscriptionMember(userData) && !userData.isClassicLens;
};

export const getRentalDateAnnotation = (date, duration = "4") => {
  const rentalStartDate = parseISOWithoutTime(date);
  const rentalEndDate = addDays(rentalStartDate, parseInt(duration) - 1);

  //Only show month for rental end date when it differs from rental start date
  const rentalEndDateFormat = isSameMonth(rentalStartDate, rentalEndDate) ? "d" : dateFnsFormats.MMM_D;

  return `${format(rentalStartDate, dateFnsFormats.MMM_D)}-${format(rentalEndDate, rentalEndDateFormat)}`;
};

export default {
  PanelNames,
  ZipPanelNames,
  SizePanelNames,
  AvailabilityPanelNames,
  MaternityPanelNames,
};
